module.exports = __webpack_public_path__ + "media/images/emblems/Commune_de_Villeneuve_(VD)-d53891f3afe7e2b70dcad7c233e0fa7b.svg";